/** Service wrappers for the auth endpoints. Errors surface to the caller. */
import type { SessionResponse, Locale } from '@genoma/shared';

import { get, post, patch } from './api.ts';

export const fetchSession = () => get<SessionResponse>('/auth/me');

export const login = (email: string, password: string) =>
  post<{ expiresAt: string }>('/auth/login', { email, password });

export const requestLoginLink = (email: string) =>
  post<{ message: string }>('/auth/magic-link', { email });

/** Exchanges the token from a magic link for a session. */
export const redeemMagicLink = (token: string) =>
  post<{ surveyId: string | null; expiresAt: string }>('/auth/magic-link/redeem', { token });

export const logout = () => post<void>('/auth/logout');


/** Change the language the signed-in person reads in. Stored on the server. */
export const setMyLocale = (locale: Locale) =>
  patch<{ locale: Locale }>('/auth/me/locale', { locale });
